"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bcp_1 = require("@iov/bcp");
const decode_1 = require("./decode");
const util_1 = require("./util");
class Context {
    constructor(chainData) {
        this.chainData = chainData;
    }
    wallet(acct) {
        return {
            address: util_1.encodeBnsAddress(util_1.addressPrefix(this.chainData.chainId), acct._id),
            balance: decode_1.ensure(acct.coins).map(c => decode_1.decodeAmount(c)),
        };
    }
    /** Decode within a Context to have the chain ID available */
    decodeOpenSwap(swap) {
        const hash = swap.preimageHash;
        if (hash.length !== 32) {
            throw new Error("Hash must be 32 bytes (sha256)");
        }
        const prefix = util_1.addressPrefix(this.chainData.chainId);
        return {
            kind: bcp_1.SwapProcessState.Open,
            data: {
                id: {
                    data: swap._id,
                },
                sender: util_1.encodeBnsAddress(prefix, decode_1.ensure(swap.source, "source")),
                recipient: util_1.encodeBnsAddress(prefix, decode_1.ensure(swap.destination, "destination")),
                hash: hash,
                // amounts: ensure(swap.amount).map(coin => decodeAmount(coin)),
                // TODO: read this is a second query
                amounts: [],
                timeout: { timestamp: decode_1.asIntegerNumber(decode_1.ensure(swap.timeout)) },
                memo: swap.memo,
            },
        };
    }
    swapOfferFromTx(confirmed) {
        const transaction = confirmed.transaction;
        return {
            kind: bcp_1.SwapProcessState.Open,
            data: {
                id: {
                    data: confirmed.result,
                },
                sender: util_1.identityToAddress(transaction.creator),
                recipient: transaction.recipient,
                hash: transaction.hash,
                amounts: transaction.amounts,
                timeout: transaction.timeout,
                memo: transaction.memo,
            },
        };
    }
}
exports.Context = Context;
//# sourceMappingURL=context.js.map